import ทายาทในกองมรดก from "./posts-thai/ทายาทในกองมรดก";
import ผู้จัดการมรดก from "./posts-thai/ผู้จัดการมรดก";
import พินัยกรรม from "./posts-thai/พินัยกรรม";
import การรับมรดกแทนที่ from "./posts-thai/การรับมรดกแทนที่";
import พระภิกษุ from "./posts-thai/พระภิกษุ";
import การเสียสิทธิรับมรดก from "./posts-thai/การเสียสิทธิในมรดก";
import ผู้ทำพินัยกรรม from "./posts-thai/ผู้ทำพินัยกรรม";
import ผู้รับพินัยกรรม from "./posts-thai/ผู้รับพินัยกรรม";
import img1 from "../../assets/thai/img_title/ทายาทในกองมรดก.png";
import img2 from "../../assets/thai/img_title/ผู้จัดการมรดก.png";
import img3 from "../../assets/thai/img_title/รับมรดกแทนที่.png";
import img4 from "../../assets/thai/img_title/พระภิกษุ.png";
import img5 from "../../assets/thai/img_title/เสียสิทธิ.png";
import img6 from "../../assets/thai/img_title/แบบพินัยกรรม.png";
import img7 from "../../assets/thai/img_title/ผู้ทำพินัยกรรม.png";
import img8 from "../../assets/thai/img_title/ผู้รับพินัยกรรม.png";

export const thaiData = [
  {
    id: 1,
    title: "ทายาทในกองมรดกสามารถเป็นใครได้บ้าง ?",
    category: "ผู้มีสิทธิรับมรดก",
    subCategory: ["ทายาท", "การรับมรดก"],
    description:
      "ทายาทในกองมรดกมี 2 ประเภท คือ ทายาทโดยธรรม และผู้รับพินัยกรรม",
    content: <ทายาทในกองมรดก />,
    cover: img1,
  },
  {
    id: 2,
    title: "ผู้จัดการมรดกคือใคร ใครสามารถเป็นได้บ้าง ?",
    category: "ผู้มีสิทธิรับมรดก",
    subCategory: ["ผู้จัดการมรดก", "ทายาท"],
    description:
      "ผู้จัดการมรดกไม่จำเป็นต้องเป็นทายาท และไม่จำเป็นต้องแต่งตั้งขึ้นมาเพียงคนเดียว สามารถแต่งตั้งได้หลายคน",
    content: <ผู้จัดการมรดก />,
    cover: img2,
  },
  {
    id: 3,
    title: "กรณีใดบ้างที่สามารถรับมรดกแทนที่กันได้",
    category: "ผู้มีสิทธิรับมรดก",
    subCategory: ["การรับมรดกแทนที่", "ทายาท"],
    description:
      "ทายาทโดยธรรมลำดับที่ 1 3 4 หรือ 6 ถึงแก่ความตายก่อนเจ้ามรดกตาย ให้ผู้สืบสันดานของทายาทนั้นรับมรดกแทนที่ หากผู้สืบสันดานตายเช่นเดียวกันก็ให้ผู้สืบสันดานของผู้สืบสันดานรับมรดกแทนที่สืบต่อกันเช่นนี้จนหมดสาย",
    content: <การรับมรดกแทนที่ />,
    cover: img3,
  },
  {
    id: 4,
    title: "พระภิกษุสามารถเป็นเจ้ามรดก หรือรับมรดกได้ไหม ?",
    category: "เกี่ยวกับพระภิกษุ",
    subCategory: ["พระภิกษุ", "ทายาท", "เจ้ามรดก"],
    description:
      "พระภิกษุสามารถเป็นทายาทในการรับมรดก และเป็นเจ้ามรดกได้ แต่การที่จะเป็นทายาทได้นั้นต้องสึกออกมาเสียก่อน",
    content: <พระภิกษุ />,
    cover: img4,
  },
  {
    id: 5,
    title: "ลักษณะแบบไหน ? ถึงเรียกว่าเสียสิทธิในการรับมรดก",
    category: "การเสียสิทธิรับมรดก",
    subCategory: ["มรดก", "การเสียสิทธิในมรดก"],
    description:
      "การเสียสิทธิในการรับมรดกจะมีทั้งหมด 4 ประการ คือ การถูกกำจัด การตัด การสละ และการสูญเสียมรดกโดยอายุความ",
    content: <การเสียสิทธิรับมรดก />,
    cover: img5,
  },
  {
    id: 6,
    title: "รูปแบบพินัยกรรม ใครสามารถทำพินัยกรรมได้บ้าง ?",
    category: "พินัยกรรม",
    subCategory: ["พินัยกรรม"],
    description:
      "พินัยกรรมมีทั้งหทด 5 รูปแบบ คือ แบบธรรมดา, แบบเขียนเองทั้งฉบับ, แบบเอกสารฝ่ายเมือง, แบบเอกสารลับ และแบบวาจา",
    content: <พินัยกรรม />,
    cover: img6,
  },
  {
    id: 7,
    title: "ความสามารถของผู้ทำพินัยกรรม",
    category: "พินัยกรรม",
    subCategory: ["พินัยกรรม", "ผู้ทำพินัยกรรม"],
    description:
      "ผู้ทำพินัยกรรมต้องมีความสามารถสมบูรณ์ตามกฎหมาย โดยสามารถทำพินัยกรรมได้ทุกคนอาจเป็นผู้เยาว์ คนไร้ความสามารถ คนวิกลจริต หรือคนเสมือนไร้ความสามารถก็ได้",
    content: <ผู้ทำพินัยกรรม />,
    cover: img7,
  },
  {
    id: 8,
    title: "ความสามารถของผู้รับพินัยกรรม",
    category: "พินัยกรรม",
    subCategory: ["พินัยกรรม", "ผู้รับพินัยกรรม"],
    description:
      "ผู้รับพินัยกรรม จะพิจารณาเฉพาะในเวลาที่ผู้ทำพินัยกรรมถึงแก่ความตายเท่านั้น",
    content: <ผู้รับพินัยกรรม />,
    cover: img8,
  },
];
